import React, { MouseEvent, TouchEvent, useRef } from "react";

const CONTROL_SELECTOR =
  "button, a, input, label, [role='button'], [role='checkbox'], [role='menuitem']";

interface LongPressProps {
  triggerElement: React.JSX.Element;
  onLongPress?: () => void;
  ignoreControls?: boolean;
}

const LongPress = ({
  triggerElement,
  onLongPress,
  ignoreControls = false,
}: LongPressProps) => {
  const timerRef = useRef<NodeJS.Timeout>(undefined);
  const startYRef = useRef<number | null>(null);
  const startXRef = useRef<number | null>(null);
  const triggeredRef = useRef(false);

  const clear = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = undefined;
    }
  };

  const onTouchStart = (e: TouchEvent) => {
    triggeredRef.current = false;
    startXRef.current = e.touches[0].screenX;
    startYRef.current = e.touches[0].screenY;

    if (onLongPress && !(ignoreControls && startsOnControl(e))) {
      timerRef.current = setTimeout(() => {
        onLongPress();
        triggeredRef.current = true;
      }, 500);
    }
  };

  const onTouchMove = (e: TouchEvent) => {
    const deltaX = Math.abs(e.touches[0].screenX - (startXRef.current ?? 0));
    const deltaY = Math.abs(e.touches[0].screenY - (startYRef.current ?? 0));
    if (deltaX > 10 || deltaY > 10) clear();
  };

  const onTouchEnd = () => {
    clear();
  };

  const handleOnClick = (e: MouseEvent) => {
    if (triggeredRef.current) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      triggerElement.props.onClick?.(e);
    }
  };

  return React.cloneElement(triggerElement, {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    onClick: handleOnClick,
  });
};

export default LongPress;

const startsOnControl = (event: TouchEvent) => {
  for (
    let node = event.target as Element | null;
    node && node !== event.currentTarget;
    node = node.parentElement
  )
    if (node.matches(CONTROL_SELECTOR)) return true;
  return false;
};
